module.exports = __webpack_public_path__ + "static/images/containers/Landing/components/LandingClans/components/TextPlate/images/pattern.f8225d3d.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/components/LandingClans/components/TextPlate/images/pattern.png
// module id = 3136
// module chunks = 11